import { h, Host } from "@stencil/core";
/**
 * Display a counter or dot beside a component to indicate action being required.
 */
export class ESBadge {
  constructor() {
    this.renderBadge = () => {
      switch (this.variant) {
        case 'dot': {
          return (h("span", { class: {
              dot: true,
              active: this.showZero || this.count > 0,
            } }));
        }
        default: {
          return (h("es-counter", { size: this.size, variant: this.variant, count: this.count, color: this.color, class: {
              active: this.showZero || this.count > 0,
            } }));
        }
      }
    };
    this.variant = 'filled';
    this.color = 'error';
    this.count = undefined;
    this.showZero = false;
    this.size = undefined;
  }
  render() {
    return (h(Host, { class: this.color }, h("slot", null), this.renderBadge()));
  }
  static get is() { return "es-badge"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-badge.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-badge.css"]
    };
  }
  static get properties() {
    return {
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "BadgeVariant",
          "resolved": "\"dot\" | \"filled\" | \"minimal\" | \"outline\"",
          "references": {
            "BadgeVariant": {
              "location": "local",
              "path": "/home/runner/work/Design-System/Design-System/packages/components/src/components/es-badge/es-badge.tsx",
              "id": "src/components/es-badge/es-badge.tsx::BadgeVariant"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Select the display variant of the badge"
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'filled'"
      },
      "color": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "HTMLEsCounterElement['color']",
          "resolved": "\"error\" | \"okay\" | \"warning\" | undefined",
          "references": {
            "HTMLEsCounterElement": {
              "location": "global",
              "id": "global::HTMLEsCounterElement"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Choose the color variant of the badge"
        },
        "attribute": "color",
        "reflect": false,
        "defaultValue": "'error'"
      },
      "count": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "What number to display in the counter (or if the dot should display)"
        },
        "attribute": "count",
        "reflect": false
      },
      "showZero": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show the dot and counter even if the count 0 (or negative)"
        },
        "attribute": "show-zero",
        "reflect": false,
        "defaultValue": "false"
      },
      "size": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number | undefined",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "The base size (in px) of the counter (has no effect on the dot)"
        },
        "attribute": "size",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=es-badge.js.map
